import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function IndexProgramSubscriptions(): Promise<ApiResponse> {
  return Axios.get("v1/subscriptions/current_program_subscription");
}
